import React, { useEffect, useState } from 'react'
import { BodyText } from '@paypalcorp/pp-react'
import { ExternalLink } from '../../external-link'
import { NavLink } from 'react-router-dom'
import PropTypes, { shape } from 'prop-types'

export const NavMenu = ({ menuList }) => {
  return (
    <ul className="dev_dash__logged_nav--items_container">
      {menuList?.map((item, idx) => {
        return <NavMenuItem item={item} key={idx} idx={idx} />
      })}
    </ul>
  )
}

const NavMenuItem = ({ item, idx }) => {
  const [hasSubMenu, setHasSubMenu] = useState(false)
  useEffect(() => {
    setHasSubMenu(item.menuItems?.length)
  }, [])

  return (
    <li
      className={`dropdown`}
      onKeyDown={(e) => {
        if (hasSubMenu && e.key === 'Enter') {
          const itemList = document.getElementById(item.title)
          itemList.classList.toggle('showMenu')
        }
      }}
      key={`nav-list-${idx}`}
    >
      <BodyText
        className={`menu-button ${
          hasSubMenu ? 'aria-haspopup="true" aria-expanded="false"' : ''
        }`}
        as={ExternalLink}
        href={item.path}
        tabIndex="0"
      >
        {item.title}
      </BodyText>
      {hasSubMenu && (
        <ul id={item.title} className={'dropdown-content'}>
          {item.menuItems.map((subItem, subIdx) => {
            const linkType = subItem.path.startsWith('https://') ? (
              <BodyText
                as={ExternalLink}
                href={subItem.path}
                target={subItem.target || '_blank'}
                key={subIdx}
              >
                {subItem.title}
              </BodyText>
            ) : (
              <BodyText
                as={NavLink}
                to={subItem.path}
                target={subItem.target || '_self'}
                key={subIdx}
              >
                {subItem.title}
              </BodyText>
            )

            return <li key={subIdx}>{linkType}</li>
          })}
        </ul>
      )}
    </li>
  )
}
export default NavMenu

NavMenu.propTypes = {
  menuList: PropTypes.array.isRequired,
}

NavMenuItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    path: PropTypes.string,
    menuItems: PropTypes.arrayOf(
      shape({
        title: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
      }),
    ),
  }),
  idx: PropTypes.number,
}
